export const EXTERNAL_CLIENTS_GROUP_REF = 'group:default/external_clients';

export type ExternalClient = {
  id: string;
  name: string;
  createdAt: string;
};

export type ExternalUser = {
  id: string;
  clientId: string;
  clientName: string;
  email: string;
  createdAt: string;
};

export function externalUserEntityRef(userId: string): string {
  return `user:default/external-${userId}`;
}
